export default __webpack_public_path__ + "static/media/566.9db8c2cc.png";